import {conditions} from "../utility/conditions";
import {ISettingsService} from "../services/settings";
import {MapFishPrint} from "../utility/map-fish-print";
import {_F} from "../utility/func";
import {expandUrl} from "./tileurlfunction";
import {arcgisLazyVectorSource} from "../utility/geo/arcgis-lazy-vector-source";
import {IExtent} from "@esri/arcgis-rest-common-types";
import {queryFeatures} from "@esri/arcgis-rest-feature-service";
import * as LTEvents from './landcare-toolkit-events';
import {LegendLayer} from "../@types/esri/Features";
import {Cluster, OSM, Source, TileWMS, VectorTile, WMTS, XYZ} from "ol/source";
import {Options as ControlOptions} from "ol/control/Control";
import {Collection, Feature, View as OlView} from "ol";
import {Layer as OlLayer, Tile, Vector as VectorLayer} from "ol/layer";
import {default as Base} from "ol/layer/Base";
import {Control, OverviewMap} from "ol/control";
import {Coordinate} from "ol/coordinate";
import Projection from "ol/proj/Projection";
import * as proj from "ol/proj";
import {transform, transformExtent} from "ol/proj";
import {containsCoordinate, Extent, getTopLeft} from "ol/extent";
import {Pixel} from "ol/pixel";
import {Size} from "ol/size";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import TileSource from "ol/source/Tile";
import TileLayer from "ol/layer/Tile";
import {optionsFromCapabilities} from "../utility/WMTS";
import TileGrid from "ol/tilegrid/TileGrid";
import {Options as TileLayerOptions} from "ol/layer/BaseTile";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import * as loadingstrategy from 'ol/loadingstrategy';
import {createXYZ} from "ol/tilegrid";
import VectorTileLayer from "ol/layer/VectorTile";
import MVT from "ol/format/MVT";
import {TileCoord} from "ol/tilecoord";
import VectorSource from "ol/source/Vector";
import {EsriJSON, GeoJSON, WMTSCapabilities} from "ol/format";
import {Circle, Fill, Stroke, Style, Text as TextStyle} from "ol/style";
import {Geometry} from "ol/geom";

/**
 *  Landcare Research Toolkit - Maps
 */
export module L {
	export let Events = LTEvents.Events;

	export interface IOlCenter {
		lat: number;
		lon: number;
		zoom: number;
	}
	export interface IOlWms {
		type: string;
		source: Source;
	}
	/*
	export interface IMap {
		id: number;
		template: string;
	}
	*/
	export enum SearchType {ADDRESS, COORDINATE, PLACE}

	export class SVGFactory {
		static ns: string = "http://www.w3.org/2000/svg";
		static create(elementTagName: string, width: number = 110, height: number = 110): Element {
			let svgElement = document.createElementNS(SVGFactory.ns, elementTagName);
			svgElement.setAttribute('width', '' + width);
			svgElement.setAttribute('height', '' + height);
			svgElement.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			return svgElement;
		}

		static createLine(x1: number, y1: number, x2: number, y2: number, strokeWidth: number, strokeColor?: string): $VG {
			let res = (new $VG('line')
				.attr('x1', '' + x1)
				.attr('x2', '' + x2)
				.attr('y1', '' + y1)
				.attr('y2', '' + y2)
				.attr('stroke-width', '' + strokeWidth));

			if (strokeColor) {
				res.attr('stroke', strokeColor);
			}
			return res;
		}
	}

	export class $VG {
		public el: SVGElement;
		constructor(tagName: string) {
			this.el = <SVGElement> SVGFactory.create(tagName);
		}

		public attr(name: string, val: string | number): $VG {
			this.el.setAttribute(name, '' + val);

			return this;
		}

		public style(name: string, val: string | number): $VG {
			this.el.style[name] = '' + val;
			return this;
		}
	}


	export class LineOptions {
		width?: number = 20;
		height?: number = 100;
		offset?: number = 20;
		strokeWidth?: number = 12;
		strokeColor?: string = 'rgba(0,60,136,.5)';
		radius?: number = 10;
	}
	export class RangeSliderOptions {
		bar: LineOptions;
		initialValue?: number;
	}

	let touchRangeSliderOptions: RangeSliderOptions = {
		bar: {
			width: 28,
			height: 110,
			offset: 14,
			strokeWidth: 12,
			strokeColor: 'rgba(0,60,136,.5)',
			radius: 14
		}
	};

	const defaultRangeSliderOptions: RangeSliderOptions = {
		bar: {
			width: 21,
			height: 110,
			offset: 11,
			strokeWidth: 10,
			strokeColor: 'rgba(0,60,136,.5)',
			radius: 11
		}
	};

	export class RangeSlider {
		protected options: RangeSliderOptions;
		protected knob: $VG;
		protected bar: $VG;
		protected svg: Element;
		protected lastBarPosition = 0;
		protected intoElement: HTMLElement;

		constructor(options: RangeSliderOptions = null) {
			this.options = options || defaultRangeSliderOptions;
			this.lastBarPosition = typeof this.options.initialValue === 'number' ? (this.options.bar.height * (this.options.initialValue / 100)) : 0;
		}

		initEvents(intoElement: HTMLElement) {
			let changing = false;
			let firstChange = true;
			let offsetY = -1;

			// let lastPercent = 0;
			let startListener = () => {
				changing = true;
			};
			let endListener = () => {
				changing = false;
				firstChange = true;
			};
			let lastY = 0;
			let getY = (event: any): number => {
				let y = event.clientY || (event.touches && event.touches[0] && event.touches[0].clientY);
				if (!isNaN(y)) {
					lastY = y;
				} else {
					y = lastY;
				}
				return y;
			};


			let moveListener = (event: any) => {
				let y = getY(event);
				if (firstChange && changing) {
					firstChange = false;
					offsetY = y + this.lastBarPosition;
					// console.log('firstChange and changing')
				}
				if (changing) {
					this.knobPos(offsetY - y);
				}
			};
			const getKnobPosition = (event) => {
				const y = getY(event);
				const bar = this.bar;
				const rect = bar.el.getBoundingClientRect();
				const doc = bar.el.ownerDocument;
				const docElem = doc.documentElement;
				const win = doc.defaultView;
				const offsetTop = rect.top + win.pageYOffset - docElem.clientTop;
				const fromTopOfBar = y - offsetTop;
                return this.options.bar.height - fromTopOfBar;
			};
			const barListener = (event: any) => {
				let newKnobPos = getKnobPosition(event);
				this.knobPos(newKnobPos);
			};

			this.knob.el.addEventListener('mousedown', startListener);
			this.knob.el.addEventListener('touchstart', startListener);

			window.addEventListener('mouseup', endListener);
			window.addEventListener('touchend', endListener);
			window.addEventListener('mousemove', moveListener);
			window.addEventListener('touchmove', moveListener);
			intoElement.addEventListener('mouseup', barListener);
			intoElement.addEventListener('touchend', barListener);
		}

		dispatchPercentEvent(percent: number): void {
			let changeEvent =
				new window['CustomEvent']('change') as unknown as TransparencySliderEvent;
			changeEvent.position = percent;
			this.intoElement.dispatchEvent(changeEvent);
		}
		/**
		 * Moves the knob to that position, bounded by the
		 * length of the bar, calculates a percent and
		 * dispatches a percent event
		 *
		 * @param position in the range 0 to the length of the bar
		 */
		knobPos(position: number) {
			let b = this.options.bar;
			position = Math.max(0, Math.min(b.height, position));

			if (position == this.lastBarPosition) {
				return;
			}

			let percent = (position / b.height) * 100;

			// console.log('knobPos', position, percent);

			// knob.attr('cy', b.offset + b.height - position);
			this.knob.attr('cy', `${b.offset + b.height - position}`);
			//            //.baseVal.value
			this.bar.style('stroke-opacity', 0.1 + 0.9 * (100 - percent) / 100);
			// lastPercent = percent;
			this.lastBarPosition = position;
			this.dispatchPercentEvent(percent);
		}
		render(intoElement: HTMLElement): Element {
			this.intoElement = intoElement;
			let o = this.options;
			let b = o.bar;
			let outerWidth = b.width;
			let svg: SVGElement = <SVGElement> this.svg;
			let newSVG = <SVGElement> SVGFactory.create('svg', outerWidth, 2 * b.offset + b.height);

			if (svg && svg.parentElement) {
				// if this has already been rendered, we replace the rendered node with a new one
				// to clean up event handlers attached to the old node
				svg.parentElement.replaceChild(svg, newSVG);
			}

			svg = this.svg = newSVG;

			let centerX = outerWidth / 2;

			this.bar = SVGFactory.createLine(
				centerX, // x1
				b.offset, // y1
				centerX, // x2
				b.offset + b.height, // y2
				b.strokeWidth);

			this.knob = new $VG('circle')
				.attr('cx', centerX)
				.attr('cy', b.offset + b.height - this.lastBarPosition)
				.attr('r', b.radius)
				.style('fill', '#fff')
				.style('cursor', 'pointer');

			svg.appendChild(this.bar.el);
			svg.appendChild(this.knob.el);
			this.knob.attr('tabindex', 5);
			let down = false;
			let up = false;
			let interval: any = null;
			const {height} = this.options.bar;
			const keydownListener = () => {
				if (up) {
					let position = this.lastBarPosition;
					if (position < height) this.knobPos(position + 1);
				}
				if (down) {
					let position = this.lastBarPosition;
					if (position > 0) this.knobPos(position - 1);
				}
			};
			this.knob.el.addEventListener('keydown', (ev) => {
				if (ev.key === 'ArrowUp') {
					up = true;
				}
				if (ev.key === 'ArrowDown') {
					down = true;
				}
			});
			this.knob.el.addEventListener('keyup', (/*ev*/) => {
				down = up = false;
			});
			this.knob.el.addEventListener('focus', () => {
				interval = setInterval(keydownListener, 50);
			});
			this.knob.el.addEventListener('blur', () => {
				clearInterval(interval);
			});

			intoElement.appendChild(svg);
			this.initEvents(intoElement);
			return svg;
		}

		setOptions(rangeSliderOptions: L.RangeSliderOptions) {
			this.options = rangeSliderOptions || defaultRangeSliderOptions;
		}
	}
	export class TransparencySliderEvent extends Event {
		position: number;
	}

	export interface TransparencySliderControlOptions extends ControlOptions {
		layers?: Collection<Base>;
		// map?: OlMap;
		layerFilter?: (l: Base) => boolean;
		initialTransparency?: number; // 0 (fully transparent) to 100 (fully opaque)
	}

	export function is_touch_device(): boolean {
		return conditions.is_touch_device();
	}

	/**
	 * Could be useful for implementing toggle-able high dpi tiles
	 * @returns {((mediaQuery:string)=>MediaQueryList)|boolean|number}
	 */
	export function is_high_density() {
		return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
	}

	export class TransparencySliderControl extends Control {
		protected layers: Collection<Base>;
		protected __element;
		protected __rangeSlider: RangeSlider;
		constructor(opt_options?: TransparencySliderControlOptions) {
			let options = opt_options ? opt_options : {};
			//see https://jsfiddle.net/qamtk4my/1/ https://jsfiddle.net/o19gmtk2/25/
			let svgDiv = document.createElement('div');
			let svgClass = 'ol-transparency-slider ol-unselectable ol-control ol-uncollapsible'
				+ (is_touch_device() ? ' touch' : '');
			svgDiv.setAttribute('class', svgClass);
			svgDiv.setAttribute('title', 'Transparency: 0%');
			let svg = new RangeSlider(is_touch_device() ? touchRangeSliderOptions : null);
			// svg.render(svgDiv);
			options.element = svgDiv;
			super(options);
			this.__element = svgDiv;
			this.__rangeSlider = svg;
			this.layers = options.layers;
			let self = this;
			svgDiv.addEventListener('change', (event: TransparencySliderEvent) => {
				let pos = event.position;
				let layers = self.layers;
                let opacity = 1 - (pos / 100);

                if (layers) {
					let layerFilter = options.layerFilter || (() => true);
					layers.forEach((item: Base) => {
							if (layerFilter(item)) {
								item.setOpacity(opacity);
							}
						});
				}
                svgDiv.setAttribute('title', 'Transparency: ' + pos + '%');
			});
		}

		public toggleTouchMode(onOrOff) {
			if (this.__element instanceof HTMLElement) {
				this.__element.classList.toggle('touch', onOrOff);
			}

			this.__rangeSlider.setOptions(onOrOff ? touchRangeSliderOptions : null);
			this.__element.innerHTML = '';
			this.__rangeSlider.render(this.__element); // render call that caused GPOENVB-659 @see render()
		}

		public setLayers(layers: Collection<Base>) {
			this.layers = layers;
		}
	}
	export module map {
		export class FitError {
			constructor(protected reason = '', protected coordinate: Coordinate) {

			}

			public toString() {
				return `${this.reason} [${this.coordinate.join(',')}]`;
			}
		}

		/**
		 *
		 *
		 * @param projection
		 * @param x
		 * @param y
		 *
		 * Returns the given coordinate in the projection, IF and only IF it is inside
		 * the given projection - otherwise an error is returned.
		 */
		export function fitCoordinates(projection: Projection, x: number, y: number): Coordinate | FitError {
			let minLon = -180.000001;
			let maxLon = 180.000001;
			let minLat = -90.000001;
			let maxLat = 90.000001;

			let projectionExtent = projection.getExtent();


			let coordinate: Coordinate = null;
			if (y >= minLon && y <= maxLon && x >= minLat && x <= maxLat) {
				coordinate = transform([y, x], 'EPSG:4326', projection);
			} else if (x >= minLon && x <= maxLon && y >= minLat && y <= maxLat) {
				coordinate = transform([x, y], 'EPSG:4326', projection);
			}

			if (coordinate !== null && containsCoordinate(projectionExtent, coordinate)) {
				return coordinate;
			}


			coordinate = [x, y];
			if (!containsCoordinate(projectionExtent, coordinate)) {
				coordinate = [y, x];
			}

			if (!containsCoordinate(projectionExtent, coordinate)) {
				// we tried but we can't get it to fit
				// return null to indicate error
				return new FitError("Coordinate outside projection.", coordinate);
			}

			return coordinate;
		}

		// declare module ol {
		// 	export interface View {
		// 		getResolutionForZoom(zoomLevel: number) : number;
		//
		// 	}
		// }

		export function  calculateAdjustedCenter(coordinate: Coordinate, view: OlView, position: Pixel, size: Size, zoomLevel: number) : Coordinate {
			if (!view || !position || !size) {
				return coordinate;
			}

			let rotation = view.getRotation();
			const cosAngle = Math.cos(-rotation);
			let sinAngle = Math.sin(-rotation);
			let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
			let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
			const resolution = (<any> view).getResolutionForZoom(zoomLevel);
			rotX += (size[0] / 2 - position[0]) * resolution;
			rotY += (position[1] - size[1] / 2) * resolution;

			// go back to original angle
			sinAngle = -sinAngle; // go back to original rotation
			const centerX = rotX * cosAngle - rotY * sinAngle;
			const centerY = rotY * cosAngle + rotX * sinAngle;

			return [centerX, centerY];
		}
	}
	export module view {
		export class GeoSearch {
			c: string;
			z: string;
			constructor(search: any) {
				this.c = search['c'];
				this.z = search['z'];
			}
			getCenter(): Coordinate {
				let parts = this.c.split(',');
				return [parseFloat(parts[0]), parseFloat(parts[1])];
			}
			getZoom(): number {
				return parseFloat(this.z);
			}
		}
	}
	export module layer {
		export type CheckBehavior = 'BASEMAP' | 'UNION' | 'UNION_SUB';
		export module Type {
			export const BASE = 'BASE';
			export const GROUP = 'SCI_GROUP';
			export const SCIENCE = 'SCIENCE';
			export const CONTEXT = 'CONTEXT';
			export const OVERVIEW = 'OVERVIEW';
			export const GROUP_UNCHECKABLE = "SCI_GROUP_CLASS_UNCHECKABLE";
		}

        export enum SERVICE_TYPES {
            ARC_GIS_FEATURE_SERVICE = 'ArcGISFeatureService',
            ARC_GIS_FEATURE_SERVICE_POINTS = 'ArcGISFeatureServicePoints',
            ARC_GIS_VECTOR_TILE = 'ArcGISVectorTile',
            LANDCARE_WMTS = 'LandcareWMTS',
            LINZ_WMTS = 'LINZ_WMTS',
            WFS = 'WFS',
            WMS = 'WMS',
            WMTS = 'WMTS'
        }

		export module ClassFlags {
			// flags from Portal Services
			// in src/main/java/org/landcare/portal/dataobjects/LayerClassFlags.java

			// export const VISUALISATION = 1;
			// export const QUERY_ABLE = 2;
			export const SHOW_LONG_NAME_IN_CONTENTS = 4;
			// export const HIDE_FROM_CONTENTS_PAGE = 8;

		}
		/*
		export class Group {
			constructor(protected layerJson: L.util.LayerService) {

			}
		}
		*/
	}
	export module util {

		export class View {
			private static view: OlView = null;
			static getZoom($location: ng.ILocationService) {
				let search: L.view.GeoSearch = new L.view.GeoSearch($location.search());
				let zoom: number = 0;
				if (search.z) {
					zoom = search.getZoom();
				}
				return zoom;
			}
			static getCenter($location: ng.ILocationService): Coordinate {
				let center: Coordinate = [1600000, 5500000];
				if ($location && $location.search) {
					let search: L.view.GeoSearch = new L.view.GeoSearch($location.search());
					if (search.c) {
						center = search.getCenter();
					}
				}
				return center;
			}
			static defaultView($location: ng.ILocationService = null): OlView {
				let center = L.util.View.getCenter($location);
				console.log('center', center);
				let zoom = L.util.View.getZoom($location);
				if (this.view !== null) {
					return this.view;
				}
				let view = new OlView({
					projection: L.util.Map.defaultProjectionObject(),
					center: center,
					resolution: 2240,
					resolutions: L.util.Resolutions.defaultResolutions(),
					constrainResolution: true,
					extent: L.util.Map.defaultExtent(),
					constrainOnlyCenter: true,
					smoothExtentConstraint: true,
					zoom: zoom
				});
				this.view = view;
				return view;
			}
		}
		export class Map {
			static defaultExtent(): [number, number, number, number] {
				return [1000000, 4700000, 2200000, 6300000];
			}
			static defaultCenter(): [number, number] {
				return [1000000, 4700000.0000001];
			}
			static defaultProjection(): string {
				return 'EPSG:2193';
			}
			static defaultProjectionObject() {
				return new Projection({
					code: 'EPSG:2193',
					units: 'm',
					extent: [274000, 3087000, 3327000, 7173000],
					// worldExtent is needed if we use Graticule
					// I have just projected the NZTM extent above, to LonLat to get the worldExtent
					worldExtent: [-170.10432972167163, -60.114544517231884, 159.93548602613785, -24.58454922303737]
				});
			}
		}
		export interface LayerClass {
			classColor: string;
			flags: number;
			id: number;
			layerName: string;
			legendOn: boolean;
			longName: string;
			param: number;
			shortName: string;
			shortNameAbbr: string;
			legendParams?: string;
			attributes?: any;
		}
		export interface LayerParams {
			format: string;
			layers: string[];
			map: string;
			transparent: boolean;
		}
		export type LayerType = 'BASE' | 'SCIENCE' | 'CONTEXT' | 'OVERVIEW' | 'SCI_GROUP' | 'SCI_GROUP_CLASS_UNCHECKABLE';

		export interface KoordinatesService {
			serviceName: string;
			serviceUrl: string;
		}

		export interface KoordinatesLayer {
			layerConfigurationId: number;
			layerName: string;
			koordinatesService: KoordinatesService;
			link?: string;
			titleProperty?: string;
			forAreaQuery?: boolean;
			forPointQuery?: boolean;
			featureName?: string;
			radius?: number;
            aboveFold?: boolean;
            order?: number;
		}

		export interface Source {
			id: number;
			name: string;
			description?: string;
		}

		export interface WFSLayer {
			id: number;
			url: string;
			typename: string;
			wfsVersion: string;
			map?: string;
            titleProperty?: string;
            forAreaQuery?: boolean;
            forPointQuery?: boolean;
            featureName?: string;
            aboveFold?: boolean;
            order?: number;
            extraOgcFilter?: string;
		}

		export interface LayerService {
			CLASS: LayerClass[];
			attributes: { [key: string]: string };
			description: string;
			id: number;
			layerName: string;
			flags?: number;
			koordinatesLayer?: KoordinatesLayer;
			legend: boolean;
			longDescription: string;
			minScale: number;
			maxScale: number;
			options: any;
			params: LayerParams;
			parentId: number;
			photoUrl: string;
			pointQuery: boolean;
			print: any;
			selected: boolean;
			'type'?: LayerType;
			url: string;
			sort: number;
			alternatives?: number[];
			alternativeClasses?: number[];
			sources?: Source[];
			WFSLayers?: WFSLayer[];
            cantBeQueriedWithTheseLayers?: number[];
            cantBeUsedToQueryTheseLayers?: number[];
            legendURL?: string;
            esriLegend?: LegendLayer;
		}
		export interface LayerJson {
			description: string;
			id: number;
			layers: LayerService[];
			longName: string;
			parentId: number;
			shortName: string;
			sort: number;
			checkBehavior?: L.layer.CheckBehavior;
			attributes?: any;
			sources?: Source[];
		}

		export interface IWMTSPrintOptions {
			resolutions: number[],
			matrixIds?: string[],
			sizes?: [number, number][],
			tileSizes?: [number, number][],
			topLeftCorners?: [number, number][],
			neu?: boolean
		}

		export class Layer {
			static olClassLayerFrom(json: LayerService, hdpi_on: boolean, param: number): OlLayer<TileSource> {
				let layer;

				if (json.attributes && json.attributes.SERVICE == 'LandcareWMTS') {
					layer = new Tile({
						source: L.util.Layer.olTileWMTSSourceFrom(json, hdpi_on, param),
						opacity: 1
					});

					layer.on('change:hdpi', () => {
						let hdpi = layer.get('hdpi');
						layer.setSource(L.util.Layer.olTileWMTSSourceFrom(json, hdpi, param))
					});
				} else {
					layer = new Tile({
						source: L.util.Layer.olTileWMSSourceFrom(json, param),
						opacity: 1
					});
				}

				L.util.Layer.setMinMaxResolutions(layer, json);

				const zIndex = json.attributes && json.attributes.zIndex && parseInt(json.attributes.zIndex)
					|| L.util.Layer.zIndexForLayerType(json.type);
				layer.setZIndex(zIndex);

				return layer;
			}
			static getLicenseKey(): string {
				let licenseJson = window['LTConfiguration']['license'] || {};

				for (let key in licenseJson) {
					if (licenseJson.hasOwnProperty(key)) {
						return key;
					}
				}
				return 'smap';
			}
			static getVariable(key: string, variable: string): string {
				let variablesJson = window['LTConfiguration']['variableMappings'];
				// first element having key and variable
				return variablesJson.filter((el) => el.Key === key && el.Variable === variable)[0];
			}
			static getLicense(display: 'screenmaps' | 'factsheets' | 'print'): string {
				const key = util.Layer.getLicenseKey();

				if (!key) return '';

				const fromVariable = util.Layer.getVariable(key, display + '_license');

				if(fromVariable && fromVariable['Value']) return fromVariable['Value'];

				return (window['LTConfiguration']['license'] || {})[key];
			}
			static encodeAttribution(display: 'screenmaps' | 'factsheets' | 'print', attribution: string) {
				const license = Layer.getLicense(display);
				return attribution.replace('{{license}}', license);
			}
			static olTileWMSSourceFrom(json: LayerService, index: number = -1): TileWMS {
				let layerName = index !== -1 ?
					json.layerName + '_class_' + (json.CLASS[index].param + 1) :
					json.layerName;
				let format = json.params && json.params.format && 'image/' + json.params.format || 'image/png';
				let source = new TileWMS({
					url: L.util.Layer.realUrl(json.url),
					projection: L.util.Map.defaultProjection(), // important! Projection param
					params: {
						'LAYERS': layerName, // LCR Layer, can be discovered from WMS GetCapabilities
						'TILED': true,
						'FORMAT': format,
						'VERSION': '1.1.1', // important! It's an old version
						'SRS': L.util.Map.defaultProjection(), // important! Projection param
						map: json.params.map
					},
					attributions: json.options.attribution ? [
						Layer.encodeAttribution('screenmaps', json.options.attribution)
					] : [],
					tileGrid: new TileGrid({
						extent: L.util.Map.defaultExtent(),
						origin: L.util.Map.defaultCenter(), // NOTE 4700000.0000001 ; important for no pink tiles
						resolutions: L.util.Resolutions.defaultResolutions()
					})
				});
				source.set('layerService', json);
				source.set('index', index);

				return source;
			}
			static realIconUrl(url: string, classNo: number = 0): string {
				const myUrl = Layer.realUrl(url);
				const urls = expandUrl(myUrl);
				return urls[classNo % urls.length];
			}
			static realUrl(url: string): string {
				if (url.substring(0, 1) !== '/') {
					return url;
				}
				const domain = window['LTConfiguration']['portalsMapsDomainName'];
				const fullUrl = domain ? 'https://' + domain + url : url;
				return decodeURIComponent(fullUrl);
			}
			static realUrlOffset(url: string, offset = 0): string {
				const myUrl = Layer.realUrl(url);
				const urls = expandUrl(myUrl);
				return urls[offset];
			}
			static olTileWMTSSourceFrom(json: LayerService, hdpi: boolean, index: number = -1) {
				let layerName = index !== -1 ?
					json.layerName + '_class_' + (json.CLASS[index].param + 1) :
					json.layerName;
				let projExtent: Extent = [274000, 3087000, 3327000, 7173000];
				let resolutions = [8960, 4480, 2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8, 1.4, 0.7, 0.28, 0.14, 0.07],
					matrixIds = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].map((i) => i.toString());

				let tileGrid = new WMTSTileGrid({
					origin: getTopLeft(projExtent),
					extent: projExtent,
					resolutions: resolutions,
					matrixIds: matrixIds
				});

				let matrixSet = hdpi ? "NZTM2000HDPI" : "NZTM2000";

				const attributions = json.options.attribution ? [
					Layer.encodeAttribution('screenmaps', json.options.attribution)
				] : [];

				layerName += hdpi ? '-HDPI' : '';
				return new WMTS({
					tileGrid: tileGrid,
					projection: "EPSG:2193",
					url: L.util.Layer.realUrl(json.url),
					format: 'jpeng',
					layer: layerName,
					style: 'default',
					tilePixelRatio: hdpi ? 2 : 1,
					matrixSet: matrixSet,
					// requestEncoding: "REST",
					attributions
				});
			}

			static olTileWMTSSourceFromCapabilities(
						$http: ng.IHttpService,
						layer: LayerService,
						capabilities: any,
						order: number,
						createPrintOptions: boolean = false) : TileLayer<WMTS> {
				const {TileMatrixSet, zIndex} = layer && layer.attributes || <{ [key: string]: string }> {};

				const result = capabilities;
				const wmtsOptions: { [key: string]: any } = {
					layer: layer.layerName
				};

				if (TileMatrixSet) {
					wmtsOptions['matrixSet'] = TileMatrixSet;
				} else {
					wmtsOptions['projection'] = "EPSG:2193";
				}

				let options: any;

				try {
					options = {
						...optionsFromCapabilities(result, wmtsOptions),
						attributions: layer.options && layer.options.attribution ? [layer.options.attribution] : undefined
					};
				} catch (e) {
					console.warn(e);
					wmtsOptions.requestEncoding = 'KVP';
					options = {
						...optionsFromCapabilities(result, wmtsOptions),
						attributions: layer.options && layer.options.attribution ? [layer.options.attribution] : undefined
					}
				}



				const source = new WMTS(options);

				const olLayer = new TileLayer({
					source,
					zIndex: zIndex !== undefined ? parseInt(zIndex) : Layer.zIndexForLayerType(layer.type, order + 1)
				});

				source.set('wmtsOptions', options);
				source.set('wmtsCapabilities', result);
				source.set('layerService', layer);

				if (createPrintOptions && TileMatrixSet) {
					const axisOrientation = source.getProjection().getAxisOrientation();

					let printConfig = this.printConfigForWMTS(
						layer.url,
						layer.layerName,
						layer.attributes.TileMatrixSet,
						source.getStyle(),
						capabilities,
						{
							resolutions: options.tileGrid.getResolutions(),
							neu : axisOrientation == 'neu'
						}
					);
					source.set('printOptions', printConfig);
				}

				return olLayer;
			}

			static printConfigForWMTS(url: string,
									  layerName: string,
									  matrixSet: string,
									  style: string,
									  capabilities: any,
									  options: IWMTSPrintOptions) : MapFishPrint.IWMTSStandardLayer {
				let tms = capabilities
						.Contents
						.TileMatrixSet.filter((tms) => tms.Identifier == matrixSet);


				let resolutions = options.resolutions || [];
				let sizes = options.sizes || [];
				let matrixIds = options.matrixIds || [];
				let tileSizes = options.tileSizes || [];
				let topLeftCorners = options.topLeftCorners || [];
				let neu = options.neu || false;

				if (tms.length) {
					let tm = tms[0].TileMatrix;
					if (!sizes.length) {
						sizes = tm.map((m) => [m.MatrixWidth, m.MatrixHeight]);
					}

					if (!matrixIds.length) {
						matrixIds = tm.map((m) => m.Identifier);
					}

					if (!tileSizes.length) {
						tileSizes = tm.map((m) => [m.TileWidth, m.TileHeight]);
					}

					if (!topLeftCorners.length) {
						let e = neu ? 1 : 0;
						let n = neu ? 0 : 1;
						topLeftCorners = tm.map((m) => [m.TopLeftCorner[e], m.TopLeftCorner[n]]);
					}
				}

				if (!resolutions.length || !sizes.length || !matrixIds.length || !tileSizes.length || !topLeftCorners.length) {
					return null;
				}

				return {
					type: 'WMTS',
					baseURL: _F.sanitizeWMTSBaseURL(url, style),
					layer: layerName,
					version: "1.0.0",
					requestEncoding: 'REST',
					style,
					dimensions: [],
					matrixSet,
					matrixIds: resolutions.map((r, idx) => {
						return {
							identifier: matrixIds[idx].toString(),
							matrixSize: sizes[idx],
							resolution: r,
							tileSize: tileSizes[idx],
							topLeftCorner: topLeftCorners[idx]
						}
					})
				};
			}

			static setMinMaxResolutions(layer: OlLayer<any>, json: LayerService) {
				let minResolution  = json.minScale ? L.util.Resolutions.resolutionFromScale(json.minScale) : 0;
				layer.setMinResolution(minResolution);

				let maxResolution = json.maxScale ? L.util.Resolutions.resolutionFromScale(json.maxScale) + 0.00001 : Infinity;
				layer.setMaxResolution(maxResolution);
			}

			static zIndexForLayerType(layerType: L.util.LayerType, customLayerOffset: number = 0) {
				let zIndexValues = {
					CONTEXT: 5000,
					BASE: 0,
					SCIENCE: 2000
				};

				let zIndex = layerType in zIndexValues ? zIndexValues[layerType] : 2000;

				return zIndex + customLayerOffset;
			}

			static singleImageWMSFrom(json: LayerService, hdpi_on: boolean, extent: Extent = null, index: number = -1): ImageLayer<ImageWMS> {
				let layerName = index !== -1 ?
					json.layerName + '_class_' + (json.CLASS[index].param + 1) :
					json.layerName;
				let format = json.params && json.params.format || 'image/png';
				let layerExtent = extent || L.util.Map.defaultExtent();
				let source = new ImageWMS({
					url: L.util.Layer.realUrl(json.url).replace('{a-d}', 'a').replace('{1-4}', '1'),
					//crossOrigin: 'anonymous',
					hidpi: hdpi_on,
					projection: L.util.Map.defaultProjection(), // important! Projection param
					params: {
						'LAYERS': layerName, // LCR Layer, can be discovered from WMS GetCapabilities
						'TILED': true,
						'FORMAT': format,
						'VERSION': '1.1.1', // important! It's an old version
						//'SRS': L.util.Map.defaultProjection(), // important! Projection param
						map: json.params.map
					},
					ratio: 1,
					//resolutions: L.util.Resolutions.defaultResolutions(),
					attributions: json.options.attribution ? [
						Layer.encodeAttribution('screenmaps', json.options.attribution)
					] : []/*,
					serverType: 'mapserver'*/
				});
				source.set('layerService', json);
				source.set('index', index);

				//return source;
				const layer = new ImageLayer({
					extent: layerExtent,
					source: source//,
					//minResolution: json.minScale
				});
				layer.setZIndex(Layer.zIndexForLayerType(json.type));
				L.util.Layer.setMinMaxResolutions(layer, json);

				return layer;
			}
			static olLayerFrom(json: LayerService, hdpi_on: boolean, extent: Extent = null): OlLayer<any> {
				let attr = json['attributes'];
				let serviceType = attr && attr['SERVICE'] ? attr['SERVICE'] : 'WMS';
				let source: TileSource;
				let isWMTS = false;
				if (serviceType === 'WMS' && json.options.singleTile) {
					let layer = L.util.Layer.singleImageWMSFrom(json, hdpi_on, extent);
					layer.set('layerService', json);
					return layer;
				}
				switch (serviceType) {
					case L.layer.SERVICE_TYPES.WMS:
						source = L.util.Layer.olTileWMSSourceFrom(json);
						isWMTS = false;
						break;
					case L.layer.SERVICE_TYPES.WMTS:
						source = L.util.Layer.olTileWMTSSourceFrom(json, hdpi_on);
						isWMTS = true;
						break;
					default:
					case L.layer.SERVICE_TYPES.LANDCARE_WMTS:
						source = L.util.Layer.olTileWMTSSourceFrom(json, hdpi_on);
						isWMTS = true;
						break;
					case L.layer.SERVICE_TYPES.ARC_GIS_FEATURE_SERVICE:
						let arcLayer = L.util.Layer.olArcGisFeatureServiceLayerFrom(json);
                        arcLayer.setZIndex(Layer.zIndexForLayerType(json.type));
						return arcLayer;
					case L.layer.SERVICE_TYPES.ARC_GIS_FEATURE_SERVICE_POINTS:
                        let pointsLayer = L.util.Layer.olArcGisFeatureServicePointsLayerFrom(json);
                        pointsLayer.setZIndex(Layer.zIndexForLayerType(json.type));
                        return pointsLayer;
					case L.layer.SERVICE_TYPES.ARC_GIS_VECTOR_TILE:
                        let vectorTileLayer = L.util.Layer.olArcGisVectorTileLayerFrom(json);
                        vectorTileLayer.setZIndex(Layer.zIndexForLayerType(json.type));
                        return vectorTileLayer;
					case L.layer.SERVICE_TYPES.WFS:
						let wfsLayer = L.util.Layer.olWfsLayerFrom(json);
                        wfsLayer.setZIndex(Layer.zIndexForLayerType(json.type));
                        return wfsLayer;
					/* // dead code:
					default:
						source = L.util.Layer.olTileWMSSourceFrom(json);
					*/
				}

				let layer_opts: TileLayerOptions<TileSource> = {
					source,
					opacity: 1
				};

				if (extent) {
					layer_opts.extent = extent;
				}

				let layer = new TileLayer(layer_opts);

				layer.setZIndex(Layer.zIndexForLayerType(json.type));
				layer.set('layerService', json);
				if (isWMTS) {
					layer.on('change:hdpi' as any, () => {
						let hdpi = layer.get('hdpi');
						layer.setSource(L.util.Layer.olTileWMTSSourceFrom(json, hdpi));
					});
				}

				L.util.Layer.setMinMaxResolutions(layer, json);

				return layer;
			}
			static linzWMTSLayer(url, wmtsStyle, layerName, layer: LayerService): TileLayer<WMTS> {
				/*
				Adapted from http://www.linz.govt.nz/data/linz-data-service/guides-and-documentation/how-to-use-lds-xyz-services-in-openlayers#custom
				Initially, we tried to use WMTS getCapabilities but the either the document was malformed,
				or the configuration that OpenLayers produced was incorrect, leading to rendering problems.

				Using the following hard-coded parameters gives good results and saves one request.
				 */
				const attributes = layer.attributes;

				const projection = proj.get('EPSG:2193');
				projection.setExtent([827933.23, 3729820.29, 3195373.59, 7039943.58]);
				const matrixSet = attributes && attributes['TileMatrixSet'] || 'EPSG:2193';
				// console.log(matrixSet, attributes, 'ATTR');

				const resolutions = [8960, 4480, 2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8, 1.4, 0.7, 0.28, 0.14, 0.07];
				const matrixIds = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
				const sizes: [number, number][] = [[2, 4], [4, 7], [8, 13], [16, 25], [31, 49], [61, 97], [121, 193], [242, 386],
				[604, 965], [1208, 1929], [2415, 3858], [6037, 9645], [12074, 19289], [24147, 38578],
				[60366, 96443], [120732, 192886], [241463, 385771]];

				const attributions = layer && layer.options && layer.options.attribution || [];

				const linzWMTSSource = new WMTS({
					layer: layerName,
					style: wmtsStyle,
					matrixSet,
					url: L.util.Layer.realUrl(url),
					requestEncoding: 'REST',
					projection: projection,
					tileGrid: new WMTSTileGrid({
						origin: [-1000000, 10000000],
						resolutions: resolutions,
						matrixIds: <any> matrixIds
					}),
					attributions
				});
				const olLayer = new TileLayer({
					source: linzWMTSSource
				});

				const mapFishConfig: MapFishPrint.IWMTSStandardLayer = {
					type: 'WMTS',
					baseURL: _F.sanitizeWMTSBaseURL(url, wmtsStyle),
					layer: layerName,
					version: "1.0.0",
					requestEncoding: 'REST',
					style: wmtsStyle,
					dimensions: [],
					matrixSet,
					matrixIds: resolutions.map((r, idx) => {
						return {
							identifier: matrixIds[idx].toString(),
							matrixSize: sizes[idx],
							resolution: r,
							tileSize: <[number, number]>[256, 256],
							topLeftCorner: <[number, number]>[-1000000, 10000000]
						}
					})
				};
				// save the print-config for when we need it later
				linzWMTSSource.set('printOptions', mapFishConfig);
				return olLayer;
			}
			static olOverviewLayer(json: LayerService): OverviewMap {
				let view = new OlView({
					projection: L.util.Map.defaultProjectionObject(),
					extent: L.util.Map.defaultExtent(),
					minZoom: 1,
					maxZoom: 3
				});
				let overviewLayer = L.util.Layer.olLayerFrom(json, true, L.util.Map.defaultExtent());
				let layer = new OverviewMap({
					layers: [
						overviewLayer
					],
					//collapseLabel: '\u00BB',
					//label: '\u00AB',
					collapsed: false,
					view: view
				});
				let overviewMap = layer.getOverviewMap();
				overviewMap.on('singleclick', function (evt) {
					layer.getMap().getView().animate({center: evt.coordinate, duration: 300});
				});
				return layer;
			}

			/**
			 * Return this icon for the layer's class at index classNumber
			 * @param {L.util.LayerService} layer
			 * @param {number} classNumber
			 * @returns {string}
			 */
			static iconForClass(layer: LayerService, classNumber: number) : string {
				if (!layer.CLASS) {
					return null;
				}

				let icon =  layer.CLASS
					.filter((it) => it.param == classNumber)
					.map((cl) => L.util.Layer.iconFrom(layer, cl, true));

				return icon.length ? icon[0] : null;
			}

			static iconFrom(layer: LayerService, classObj: LayerClass = null, layerFromClass: boolean = false): string {
				// /wms/zentilegen-a/mapcache/oe/?FORMAT=image%2Fgif&MAP=%2Fopt%2Fmapserver%2Fmapfiles%2Flri.map&TRANSPARENT=TRUE&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetLegendGraphic&EXCEPTIONS=application%2Fvnd.ogc.se_xml&LAYER=lri_rock_group_full&MODE=legendicon&ICON=lri_rock_group_full%2C0
				let ICON: string = layer.layerName;
				if (layer.attributes && layer.attributes.SERVICE == 'TileXYZ' && classObj && classObj.classColor) {
					let border = classObj.attributes && classObj.attributes.LegendChipBorder;
					return _F.colourToLegendChip(35, 15, classObj.classColor, null, border);
				}
				let LAYER = classObj ? layer.layerName : layer['CLASS'][0].layerName;

				if (classObj) {
					if (layerFromClass) {
						ICON = classObj.layerName + ',' + (classObj.param);
					} else {
						ICON += ',' + (classObj.param);
					}
				} else {
					classObj = layer['CLASS'][0];
					ICON = LAYER + ',0';
				}

				let params: any = {
					FORMAT: 'image/gif',
					MAP: layer.params.map,
					TRANSPARENT: true,
					SERVICE: 'WMS',
					VERSION: '1.1.1',
					REQUEST: 'GetLegendGraphic',
					EXCEPTIONS: 'application/vnd.ogc.se_xml',
					LAYER,
					MODE: 'legendicon',
					ICON
				};

				let baseURL = layer.attributes && layer.attributes['AltLegendURL'] || layer.url;

				const query = new URLSearchParams(params).toString();
				let url = L.util.Layer.realIconUrl(baseURL + query, classObj && classObj.param || 0);
				if (classObj.legendParams) {
					url += `&${classObj.legendParams}`;
				}
				return url;
			}

			static getUserVisibleAttributes(ls: LayerService|LayerClass|LayerJson) : L.tree.ItemAttribute[] {
				if (!ls) return [];
				let attrs = ls['attributes'] || {};
				let weAreInterestedIn = ['Source', 'Covers','Includes'];

				let result =  weAreInterestedIn.map((l) => {
					if (attrs[l]) {
						return {
							key: l,
							value: attrs[l]
						};
					}
					return null;
				}).filter((e) => e);

				if (ls['flags']) {
					let lc = <LayerClass> ls;
					let showLongName = lc.flags & L.layer.ClassFlags.SHOW_LONG_NAME_IN_CONTENTS;
					if (lc.flags && showLongName) {
						result.push({
							key: 'Includes',
							value: (<LayerClass>lc).longName
						});
					}
				}

				return result;
			};

            private static olArcGisFeatureServiceLayerFrom(json: L.util.LayerService) : VectorLayer<VectorSource<Geometry>> {
            	return new VectorLayer({
                    source: arcgisLazyVectorSource({
						url: `${json.url}${json.params.layers}`,
						strategy: loadingstrategy.tile(createXYZ({
                            tileSize: 512
                        }))
					})
                });
            }

            private static olArcGisVectorTileLayerFrom(json: L.util.LayerService) : VectorTileLayer {
            	let source = new VectorTile({
                    format: new MVT(),
                    url: json.url,
                    projection: "EPSG:3857",
					tileUrlFunction: function(tileCoord: TileCoord) {
                        let grid = source.getTileGrid();
                        let extent = transformExtent(grid.getTileCoordExtent(tileCoord),
                            "EPSG:2193", "EPSG:3857");

                        let quant = {
                            "mode":"view",
                            "originPosition":"upperLeft",
                            "tolerance":1222.992452562501,
                            "extent": {
                                "xmin":extent[0],
                                "ymin":extent[1],
                                "xmax":extent[2],
                                "ymax":extent[3],
                                "spatialReference":{
                                    "wkid":102100,
                                    "latestWkid":3857
                                }
                            }
                        };

						return `${json.url}${json.params.layers}/query/?f=pbf&` +
							'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
							encodeURIComponent('{"xmin":' + extent[0] + ',"ymin":' +
								extent[1] + ',"xmax":' + extent[2] + ',"ymax":' + extent[3] +
								',"spatialReference":{"wkid":102100,"latestWkid":3857}}') +
							'&geometryType=esriGeometryEnvelope&inSR=102100&outFields=*' +
							'&outSR=102100&returnCentroid=false&resultType=tile' +
							'&quantizationParameters=' + encodeURIComponent(JSON.stringify(quant));
					}
                });

				return new VectorTileLayer({
					source,
					renderOrder: undefined
				});
            }

            private static olWfsLayerFrom(json: L.util.LayerService, srsName: string = 'EPSG:2193') {
            	let source = new VectorSource({
					format: new GeoJSON(),
					url: function (extent) {
						let typeNames = json.attributes.TypeNames;
						return `${json.url}?service=WFS&version=1.1.0&request=GetFeature&typeName=${typeNames}`
							+ `&outputFormat=application/json&srsName=${srsName}&bbox=${extent.join(',')},${srsName}`;
                    },
					strategy: loadingstrategy.bbox
				});

				return new VectorLayer({
					source
				});
            }

            private static olArcGisFeatureServicePointsLayerFrom(json: L.util.LayerService) {
            	let format = new EsriJSON();
            	let url = `${json.url}${json.params.layers}`;
				let pointsSource = new VectorSource({
					format,
					loader: (extentFromMap, resolution, projection) => {
                        let sr = projection.getCode().split(":")[1];
                        queryFeatures({
                            url,
                            returnGeometry: true,
                            spatialRel: 'esriSpatialRelIntersects',
                            geometry: <IExtent> {
                                xmin: extentFromMap[0],
                                ymin: extentFromMap[1],
                                xmax: extentFromMap[2],
                                ymax: extentFromMap[3],
                                spatialReference: {
                                    wkid: parseInt(sr)
                                }
                            },
                            geometryType: "esriGeometryEnvelope",
                            outFields: '*',
                            outSR: sr
                        }).then((resp : any) => {
                        	pointsSource.addFeatures((<any> format).readFeaturesFromObject(resp));
						});
					},
					strategy: loadingstrategy.bbox
				});

				let source: VectorSource<Geometry> = pointsSource;

				let baseStyleFeatureCache = {};

				let fillColor = 'rgba(61,63,49,0.8)';

				let baseStyle = (feature: Feature<Geometry>) => {
					let id = feature.getId();
					if (baseStyleFeatureCache[id]) return baseStyleFeatureCache[id];

					let text =  feature.get('Name');
					console.log('Feature text ', text);
					let style = new Style({
                        image: new Circle({
                            radius: 4,
                            /*stroke: new Stroke({
                                color: "#535353"
                            }),*/
                            fill: new Fill({
                                color: fillColor
                            })
                        }),
                        text: new TextStyle(<any> {
                        	text,
                            overflow: true,
							offsetX: -12,
							textAlign: 'right',
                            fill: new Fill({
                                color: '#000'
                            }),
                            stroke: new Stroke({
                                color: '#fff',
								width: 3
                            })
                        })
                    });

					baseStyleFeatureCache[id] = style;

					return style;
				};


				const clustering = json.attributes.Clustering == 'true';

				if (clustering) {
					source = new Cluster({
						distance: 32,
						source: pointsSource
					});
				}

				let layer = new VectorLayer(<any> {
					source,
					declutter: true
				});

				if(clustering) {
                    let styleCache : {[size: number]: Style } = {

                    };

                    let styleFn = (feature) => {
                    	let features = <Feature<Geometry>[]> feature.get('features');
                        let size = features.length;
                        if (size == 1) {
                            return baseStyle(features[0]);
                        }

                        let style = styleCache[size];
                        if (style) return style;

                        style = new Style({
                            image: new Circle({
                                radius: Math.min(8 * Math.sqrt(size), 16),
                                stroke: new Stroke({
                                    // color: "#535353"
                                    color: "#535353"
                                }),
                                fill: new Fill({
                                    // color: "#cd6865"
                                    color: fillColor
                                    // color: "rgba(0,0,0,0.8)"
                                })
                            }),
                            text: new TextStyle(<any> {
                                overflow: true,
                                text: size.toString(),
                                fill: new Fill({
                                    color: '#fff'
                                })/*,
								stroke: new Stroke({
									color: '#fff',
									width: 3
								})*/
                            })
                        });

                        styleCache[size] = style;
                        return style;
                    };
                    layer.setStyle(styleFn);
				} else {
					layer.setStyle(baseStyle);
				}


				return layer;
            }
        }
        export class Resolutions {
            private static scales = [
                8000000, 4000000, 2000000, 1000000, 500000, 250000, 100000, 50000, 25000, 10000
            ];

            private static resolutions = [
                2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8
            ];

            static scaleFromResolution(resolution: number) : number {
                let index = Resolutions.resolutions.indexOf(resolution);
                if (index === -1) {
                    let closest = [].concat(Resolutions.resolutions).sort((a, b) => Math.abs(a - resolution) - Math.abs(b - resolution));
                    console.log(`scaleFromResolution: returning scale based on closest resolution  to ${resolution} ${closest}`)
                    index = Resolutions.resolutions.indexOf(closest[0]);
                }

                return Resolutions.scales[index];
            }

            static resolutionFromScale(scale: number): number {
                let index = Resolutions.scales.indexOf(scale);
                if (index === -1) {
                    throw new Error('No such scale/resolution');
                }
                return Resolutions.resolutions[index];
            }
            static defaultResolutions(): number[] {
                return Resolutions.resolutions;
            }
        }
		export class Polyfills {
			static requestAnimationFrame(step: FrameRequestCallback): any {
				if ('requestAnimationFrame' in window) {
					return window.requestAnimationFrame(step);
				} else {
					return setTimeout(step, 300);
				}
			}
		}


		export interface ITreeDataFromLayerJsonOptions {
			includeAllItems: boolean;
			expandedGroups: boolean;
		}

		export function treeDataFromLayerJson(
			$http: ng.IHttpService,
			response: any,
			settingsService: ISettingsService,
			options: ITreeDataFromLayerJsonOptions = {
				includeAllItems: true,
				expandedGroups: true
			},
		) {
			let index = 0; // index for the treeitem
			let layerJson: L.util.LayerJson[] = [...response.collections || []]
				.sort((a, b) => {
					return a.sort - b.sort;
				});
			let overviewLayer;
			let rootItems: L.tree.Item[] = [];

			let hdpi_on = is_high_density();

			if (settingsService.getHdpi() == 'hdpi') hdpi_on = true;
			if (settingsService.getHdpi() == 'standard') hdpi_on = false;

			if (!(layerJson instanceof Array) || !layerJson.length) {
				return;
			}

			let treeData: any[] = [];
			let subCollections = {};


			let layers: OlLayer<any>[] = [];

			let tranparencyLayers: OlLayer<any>[] = [];
			for (let collection of layerJson) {
				index++;
				let collectionItem: L.tree.Item = {
					name: collection.shortName,
					checkBehavior: collection.checkBehavior,
					selected: false,
					children: null,
					xorGroups: [],
					notInXorGroups: [],
					index,
					xorGroup: collection.attributes && collection.attributes['XORGroup'],
					rootItems,
					extraState: {
						metaLayerSelector: {
							checked: collection.checkBehavior == "BASEMAP" || collection.checkBehavior == "UNION" || options.includeAllItems,
							expanded: false
						}
					},
					attributes: L.util.Layer.getUserVisibleAttributes(collection),
					longName: collection.longName,
					photoUrl: collection['photoUrl']
				};

				if (collection.sources) {
					collectionItem.sources = collection.sources;
				}

				if (collection.parentId < 0) {
					rootItems.push(collectionItem);
				}

				index++;
				let children: L.tree.Item[] = [];
				const sortedLayers = [...collection.layers].sort((a, b) => {
					return (a.sort - b.sort) || 0;
				});
				for (let layer of sortedLayers) {
					if (layer.type === L.layer.Type.OVERVIEW) {
						overviewLayer = L.util.Layer.
							olOverviewLayer(layer);
						continue;
					}
					let attributes = layer.attributes;
					// If a layer has 'conditions' then, the layer will
					// only be enabled if those conditions are met
					let conditionEnv = {
						COMBINED_LAYERS: settingsService.combinedLayerClasses(),
						TOUCH: settingsService.isTouchEnabled()
					};

					let showLayerConditions = attributes && attributes['Conditions'];
					if (showLayerConditions) {
						try {
							if (!conditions.evalConditions(showLayerConditions, conditionEnv)) {
								// we don't want to use this layer on this type of device.
								continue;
							}
						} catch (e) {
							console.log(e);
						}

					}

					let alts = layer.alternatives || [];
					for (let alternativeLayerId of alts) {
						let alt = sortedLayers.filter((l) => l.id == alternativeLayerId);
						if (!alt.length) continue;
						let theAlt = alt[0];
						if (theAlt.type === L.layer.Type.GROUP) {
							layer = {
								...layer,
								alternativeClasses: theAlt.CLASS.map((c) => c.id)
							}
							// layer.alternativeClasses = theAlt.CLASS.map((c) => c.id);
						}
					}

					let classChildren: L.tree.Item[] = [];
					let extraClasses = layer.attributes && layer.attributes.ExtraCSSClasses;
					let xorGroup = layer.attributes && layer.attributes.XORGroup;

					const expanded = layer.selected
                        && [L.layer.Type.SCIENCE, L.layer.Type.GROUP, L.layer.Type.GROUP_UNCHECKABLE].includes(layer.type)
                        && (layer.CLASS || []).length > 1;

					let treeItem: L.tree.Item = {
						name: null,
						layer: null,
						extraCSSClasses: extraClasses,
						xorGroup: xorGroup,
						expanded,
						index: index,
						rootItems,
						extraState: {
							metaLayerSelector: {
								checked: layer.type == 'CONTEXT' || layer.type == 'BASE' || options.includeAllItems, // Only include context or base layers by default
								expanded: false
							}
						},
						attributes: L.util.Layer.getUserVisibleAttributes(layer),
						longName: layer.longDescription,
						photoUrl: layer.photoUrl
					};

					if (layer.sources) {
						treeItem.sources = layer.sources;
					}

					index++;
					if (layer.type === L.layer.Type.GROUP) {
						const sortedClasses = [...layer.CLASS].sort((a, b) => {
							return a.param - b.param;
						});
						for (let cl of sortedClasses) {
							let iconFromClass = cl && cl.layerName && cl.layerName !== layer.layerName;
							let icon = L.util.Layer.iconFrom(layer, cl, iconFromClass);
							let classLayer;
							try {
								classLayer = L.util.Layer.olClassLayerFrom(layer, hdpi_on, cl.param);
							} catch (error) {
								console.warn(error);
								L.util.Layer.olClassLayerFrom(layer, hdpi_on, cl.param);
								continue;
							}
							classLayer.on('precompose', (ev: any) => {
								ev.context.globalCompositeOperation = window['composeFn'] || 'source-over';
							});
							classLayer.on('postcompose', (ev: any) => {
								ev.context.globalCompositeOperation = 'source-over';
							});
							let classItem : L.tree.Item = {
								name: cl.shortName,
								parent: treeItem,
								layer: classLayer,
								extraCSSClasses: 'class',
								click: L.tree.clickItem,
								icon: '<img src="' + icon + '" alt="' + cl.longName + '" />',
								iconUrl: icon,
								isChecked: L.tree.isChecked,
								selected: layer.selected,
								classId: cl.id,
								index: index,
								rootItems,
								extraState: {
									metaLayerSelector: {
										checked: options.includeAllItems,
										expanded: false
									}
								},
								attributes: L.util.Layer.getUserVisibleAttributes(cl)
							};

							classItem.layerSelectorChildren = null; /*classItem
								.attributes
								.map((a) => L.util.Layer.userVisibleAttributeAsItem(a, classItem))
								*/
							classLayer.set('isDefaultLayer', layer.selected);

							classChildren.push(classItem);
							index++;
							classLayer.setVisible(layer.selected);
							// tranparencyLayers.push(classLayer);
							classLayer.set('transparencyLayer', true);
							layers.push(classLayer);
						}
					} else if (layer.CLASS && layer.CLASS.length === 1) {
						treeItem.iconUrl = L.util.Layer.iconFrom(layer, null);
					} /*else if ([L.layer.Type.SCIENCE, L.layer.Type.GROUP_UNCHECKABLE].includes(layer.type)) {
						classChildren = layer.CLASS.sort((a, b) => {
								return a.param - b.param;
							}).map<Item>(cl => {
								const iconFromClass = cl && cl.layerName && cl.layerName !== layer.layerName;
								const icon = L.util.Layer.iconFrom(layer, cl, iconFromClass);
								index++;
								return {
									name: cl.shortName,
									parent: treeItem,
									click: () => {},
									icon: '<img src="' + icon + '" alt="' + cl.longName + '" />',
									iconUrl: icon,
									isChecked: () => false,
									layerSelectorChildren: null,
									selected: false,
									classId: cl.id,
									index: index,
									rootItems,
									extraState: {
										metaLayerSelector: {
											checked: options.includeAllItems,
											expanded: false
										}
									},
									attributes: L.util.Layer.getUserVisibleAttributes(cl)
								}
						});
					}*/

					treeItem.name = layer.description;
					treeItem.children = classChildren;

					if (layer.type == L.layer.Type.GROUP) {
						treeItem.layerSelectorChildren = [].concat(treeItem.children);
					} else if (layer.CLASS) {
						// noinspection JSBitwiseOperatorUsage
						const classItems: L.tree.Item[] = layer.CLASS
							.filter((cl) => cl.flags && !(cl.flags & 8))
							.filter(cl => cl.legendOn && cl.shortName)
							.map<L.tree.Item>((cl) => {
									let iconFromClass = cl && cl.layerName && cl.layerName !== layer.layerName;
									let icon = L.util.Layer.iconFrom(layer, cl, iconFromClass);
									return {
										name: cl.shortName,
										parent: treeItem,
										click: (node) => {
											L.tree.clickItem(node);
										},
										icon: '<img src="' + icon + '" alt="' + cl.longName + '" />',
										iconUrl: icon,
										isChecked: L.tree.isChecked,
										selected: layer.selected,
										classId: cl.id,
										index: index++,
										rootItems,
										extraCSSClasses: "class-no-layer",
										extraState: {
											metaLayerSelector: {
												get checked() { return treeItem.extraState.metaLayerSelector.checked; },
												set checked(value: boolean) {}, // no-op
												expanded: true
											}
										},
										attributes: L.util.Layer.getUserVisibleAttributes(cl)
									}
								}
							);

						treeItem.layerSelectorChildren = [...treeItem.children, ...classItems];
						if (treeItem.layerSelectorChildren.length) {
							treeItem.children = treeItem.layerSelectorChildren;
						}
					} else {
						treeItem.layerSelectorChildren = [];
					}

					treeItem.isChecked = L.tree.isChecked;
					treeItem.selected = layer.selected;
					treeItem.parent = collectionItem; // needed for check behavior!
					treeItem.click = L.tree.clickItem;
					treeItem.layerType = layer.type;

					let olLayer = null;
					if (layer.attributes && layer.attributes.SERVICE) {
						switch (layer.attributes.SERVICE) {
							case 'OSM':
								olLayer = new TileLayer({
									source: new OSM()
								});
								break;
							case 'LandcareWMTS':
								//console.log('LandcareWMTS', layer);
								if (layer.type == L.layer.Type.GROUP) {
									break; // ignore class layers because already handled above
								}

								try {
									olLayer = L.util.Layer.olLayerFrom(layer, hdpi_on);
								} catch (error) {
									console.warn(error);
									continue;
								}

								/*olLayer = new TileLayer({
									source: L.util.Layer.olTileWMTSSourceFrom(layer)
								});*/

								olLayer.set('layerService', layer);

								break;
							case 'LINZ_WMTS':
								let url = layer.url;
								let wmtsStyle = layer.attributes.WMTS_STYLE;
								let layerName = layer.layerName;

								olLayer = L.util.Layer.linzWMTSLayer(url, wmtsStyle, layerName, layer);
								olLayer.getSource().set('layerService', layer);
								break;
							case 'WMTS':
								olLayer = new TileLayer({
									source: null
								});


								$http.get<string>(layer.url, {cache: true}).then((resp) => {
									let parser = new WMTSCapabilities();
									let result = parser.read(resp.data);

									let wmtsOptions = {
										layer: layer.layerName
									};

									if (layer.attributes.TileMatrixSet) {
										wmtsOptions['matrixSet'] = layer.attributes.TileMatrixSet;
									} else {
										wmtsOptions['projection'] = "EPSG:2193";
									}

									const source = new WMTS({
										...optionsFromCapabilities(result, wmtsOptions),
										attributions: layer.options && layer.options.attribution ? [layer.options.attribution] : undefined
									});

									olLayer.setSource(source);
									source.set('wmtsOptions', options);
									source.set('wmtsCapabilities', result);
									source.set('layerService', layer);
								});
								break;
							case 'TileXYZ':
								olLayer = new TileLayer({
									source: new XYZ({
                                        url: layer.url
                                    })
								});
								break;
							case 'WMS':
							default:
								olLayer = L.util.Layer.olLayerFrom(layer, hdpi_on);
								break;
						}
					} else if (layer.type !== L.layer.Type.GROUP) {
						olLayer = L.util.Layer.olLayerFrom(layer, hdpi_on);
					}
					if (olLayer) {
						const zIndex = layer.attributes && layer.attributes.zIndex && parseInt(layer.attributes.zIndex) || L.util.Layer.zIndexForLayerType(layer.type);
						olLayer.setZIndex(zIndex);
						olLayer.setVisible(layer.selected);
						olLayer.set('isDefaultLayer', layer.selected);
						if (layer.type === L.layer.Type.SCIENCE || layer.type === L.layer.Type.GROUP) {
							olLayer.on('precompose', (ev: any) => {
								ev.context.globalCompositeOperation = window['composeFn'] || 'source-over';
							});
							olLayer.on('postcompose', (ev: any) => {
								ev.context.globalCompositeOperation = 'source-over';
							});
						}

						treeItem.layer = olLayer;
						treeItem.layerId = layer.id;
						if (layer.type.indexOf('SCI') === 0) {
							// tranparencyLayers.push(olLayer);
							olLayer.set('transparencyLayer', true);
						}
						layers.push(olLayer);
					}


					treeItem.layerService = layer;

					children.push(treeItem);
				}
				let selected = false;
				for (let item of children) {
					if (item.selected) {
						selected = true;
						break;
					}
				}
				let groups = {};
				children && children.filter((node: L.tree.Item) => node.layerService && node.layerService.attributes && node.layerService.attributes['XORGroup'])
					.forEach((node: L.tree.Item) => {
						let g = node.layerService.attributes['XORGroup'];
						if (!groups[g]) {
							groups[g] = [];
						}
						groups[g].push(node);
					});

				let res = [];
				for (let k in groups) {
					if (groups.hasOwnProperty(k)) {
						res.push(groups[k]);
					}
				}

				collectionItem.xorGroups = res;
				collectionItem.notInXorGroups = (children && children
					.filter((node: L.tree.Item) => !(node.layerService && node.layerService.attributes && node.layerService.attributes['XORGroup'])))
					|| [];

				collectionItem.click = L.tree.clickItem;
				collectionItem.isChecked = L.tree.isChecked;
				collectionItem.checkBehavior = collection.checkBehavior;
				collectionItem.selected = selected;
				children = children.reverse(); // real order!
				collectionItem.children = children;

				collectionItem.layerSelectorChildren = [].concat(children);
					/*collection
						.attributes
						.map((a) => L.util.Layer.userVisibleAttributeAsItem(a, collectionItem))
						.concat(children);*/

				let attributes = collection['attributes'];
				// let expanded = attributes && attributes['Expanded'];
				collectionItem.expanded = options.expandedGroups; //expanded && expanded === 'true';
				collectionItem.extraCSSClasses = attributes && attributes['ExtraCSSClasses'];
				collectionItem.id = collection.id;
				if (collection.parentId !== -1) {
					subCollections['' + collection.parentId] = collectionItem;
				} else {
					treeData.push(collectionItem);
				}
			}

			treeData = treeify(treeData, subCollections);
			return {
				treeData,
				layers,
				tranparencyLayers,
				overviewLayer
			}
		}
		function treeify(treeData: L.tree.Item[], subCollections: {}) {
			treeData = treeData.reverse();
			Object.keys(subCollections).map(k => {
				let items = treeData.filter(item => item.id + '' === k);
				if (items.length) {
					let collection: L.tree.Item = subCollections[k];
					let e = items[0];

					e.children.push(collection);

					let idx = e.children.length;
					e.layerSelectorChildren.splice(idx, 0, collection);

					collection.parent = e;
				}
			});

			return treeData;
		}
	}
	export module tree {
        import WFSLayer = L.util.WFSLayer;
        import KoordinatesLayer = L.util.KoordinatesLayer;

        export interface ItemState {
			checked?: boolean;
			expanded?: boolean;
			deleting?: boolean;
		}

		export interface Item {
			id?: number;
			name: string;
			isCustom?: boolean;
			isLocalData?: boolean;
			isError?: boolean;
			isChecked?: () => boolean;
			childChecked?: () => boolean;
			layer?: OlLayer<any>,
			iconUrl?: string; // the icon URL
			icon?: string; // <img /> element with iconUrl as src
			checked?: boolean;
			checkBehavior?: L.layer.CheckBehavior;
			selected?: boolean;
			click?: (node: Item) => void;
			showLegend?: (node: Item) => void;
			showMetaData?: (node: Item) => void;
			parent?: Item;
			children?: Item[];
			layerSelectorChildren?: Array<Item>;
			layerType?: L.util.LayerType;
			extraCSSClasses?: string;
			expanded?: boolean;
			xorGroup?: string;
			classId?: number;
			layerId?: number;
			layerService?: L.util.LayerService;
			sourceService?: L.util.Source;
			index: number; // needed for treeitem!
			xorGroups?: Item[][];
			notInXorGroups?: Item[];
			extraState: {
				metaLayerSelector: ItemState
			}
			//getLegend?: ($scope: ng.)
			rootItems: Item[];
			attributes?: ItemAttribute[] // user visible metadata
			description?: string;
			longName?: string;
			photoUrl?: string;
			sources?: L.util.Source[];
			styleDefinition?: any;
		}

		export interface ItemAttribute {
			key: string;
			value: string;
		}

		export function checkChildren(node: Item, recursive: boolean = true, handleXor: boolean = true): void {
			if (!node.children) {
				return;
			}

			node.children.forEach((child) => {
				child.checked = true;
				if (child.layer) {
					child.layer.setVisible(true);
				}
				if (recursive) {
					checkChildren(child);
				}
			});

			if (handleXor) {
				// handle xor groups!
				node.children.forEach((child) => {
					if (child.checked) {
						uncheckOthersInXORGroup(child);
					}
				});
			}
		}

		export function checkChildrenWithInclude(node: Item, includedOnly: boolean = true) {
			node.checked = true;
			if (node.layer) node.layer.setVisible(true);
			if (node.layerType === 'SCI_GROUP') {
				node.children
					.filter((c) => c.extraState.metaLayerSelector.checked)
					.forEach((c) => checkChildrenWithInclude(c, includedOnly));
			}
		}

		export function mapNodes<T>(node: Item|Item[], f: (Item) => T): T[] {
			if (node instanceof Array) {
				return node.reduce((acc, n) => [...mapNodes(n, f), ...acc], []);
			} else {
				const t = f(node);

				if (node && node.children) {
					return [t, ...mapNodes(node.children, f)];
				}

				return [t];
			}
		}

		export function forEachNode(node: Item|Item[], f: (Item) => void) {
			if (node instanceof Array) {
				for (let child of node) {
					forEachNode(child, f);
				}
			} else {
				f(node);

				if (node && node.children) {
					forEachNode(node.children, f);
				}
			}
		}

		export function filterNodes(node: Item | Item[], f: (Item) => boolean): Item[] {
			let result = [];
			if (node instanceof Array) {
				for (let child of node) {
					result.push(...filterNodes(child, f));
				}
			} else {
				if (f(node)) {
					result.push(node);
				}

				if (node && node.children) {
					result.push(...filterNodes(node.children, f));
				}
			}
			return result;
		}

		export function findNode(node: Item|Item[], f:(Item) => boolean) : Item {
			if (node instanceof Array) {
				for (let n of node) {
					const result = findNode(n, f);
					if (result) return result;
				}
				// return node.find((n) => findNode(n, f));
			} else {
				if (f(node)) return node;
				if (node && node.children) {
					return findNode(node.children, f);
				}
			}
			return null;
		}

		export function someNodes(node: Item|Item[], f:(Item) => boolean) : boolean {
			/*if (node instanceof Array) {
				return node.some((n) => someNodes(n, f));
			} else {
				if (f(node)) return true;
				if (node && node.children) {
					return someNodes(node.children, f);
				}
			}
			return false;*/
			return !!findNode(node, f);
		}

		export function getVisibleLayers(node: Item | Item[]): Item[] {
			return filterNodes(node, (item: Item) => item &&
				(item.isChecked() ||
					(item.layerType === 'SCI_GROUP' && item.children.length
						&& filterNodes(item.children, (f) => f.isChecked()).length > 1)));
		}

		export function getDefaultLayers(layerTree: Item|Item[]): Item[] {
			return filterNodes(layerTree, (n: Item) => n.layer.get('isDefaultLayer'));
		}

		export function nodeIsScienceLayer(n : Item) : boolean {
			return n && !n.isCustom && (n.layerType === 'SCI_GROUP'
				|| n.layerType === 'SCI_GROUP_CLASS_UNCHECKABLE'
				|| (n.layerType === 'SCIENCE' && n.layerService.layerName !== 'smap_polys_anno'));
		}

		export function isQueryAble(l: L.tree.Item) : boolean {
			return (l && l.layerService) ? l.layerService.pointQuery : true;
		}

		export function isSuitableForQuerying(contextLayer: Item, scienceLayer: Item) : boolean {
			let ls = scienceLayer.layerService;
			if (ls.cantBeQueriedWithTheseLayers) {
				return ls.cantBeQueriedWithTheseLayers.indexOf(contextLayer.layerId) == -1;
				// return !ls.cantBeQueriedWithTheseLayers.some((id) => id == contextLayer.layerId);
			}
			return true;
		}

        export function isCollection(node: Item): boolean {
		    return node && !node.layerId
                && !node.layer
                && !node.classId
                && node.layerType !== "SCI_GROUP"
                && node.layerType !== "SCI_GROUP_CLASS_UNCHECKABLE";
        }

		export function getScienceLayers(node: Item | Item[]): Item[] {
			return filterNodes(node, nodeIsScienceLayer);
		}

		/**
		 * Returns items in a node tree which are visible science layers
		 * @param {L.tree.Item | L.tree.Item[]} node
		 * @returns {L.tree.Item[]}
		 */
		export function getVisibleScienceLayers(node: Item | Item[]) : Item[] {
			return getScienceLayers(node)
				.filter((item) => item.isChecked()
						|| (item.children && item.children.some((child) => child.isChecked())))
		}

		export function getIncludedScienceLayers(node: Item | Item[]) : Item[] {
			return getScienceLayers(node)
				.filter((n) => n && n.extraState.metaLayerSelector.checked);
		}

		export function getKoordinatesApiLayers(node: Item|Item[]) : Item[] {
			return L.tree.filterNodes(node, (item : L.tree.Item) =>
				item && item.layerService && !!item.layerService.koordinatesLayer );
		}

		export function getLayerServiceType(item: Item) : string {
            try {
                return item.layerService.attributes.SERVICE
            }
            catch (e) {
				return null;
            }
        }

		/**
		 * Returns the layer groups which should be shown in the add/remove layers panel
		 * i.e. it will exclude the context and base layers
		 * @param groups
		 */
		export function getUserSelectableLayers(groups: Item[]): Item[] {
			return groups.filter((group : Item) => {
				return group.children.some((l) =>
					l.isCustom || (l.layerType !== 'CONTEXT' && l.layerType !== 'BASE' && l.layerType !=='OVERVIEW'));
			});
		}


        export function getEsriLayers(treeData: Item[]|Item) : Item[] {
            return filterNodes(treeData, (item) => getLayerServiceType(item) == L.layer.SERVICE_TYPES.ARC_GIS_FEATURE_SERVICE);
        }

		export function getQueryableLayers(node: Item|Item[]) : Item[] {
			return L.tree.filterNodes(node, (item : L.tree.Item) => {
				let layerService = item && item.layerService;
				if (!layerService) return false;

				if (layerService.koordinatesLayer) return true;

				return layerService.WFSLayers && layerService.WFSLayers.length > 0;
			});
		}

		export function getLayersForAreaQuery(node: Item|Item[]) : Item[] {
            return L.tree.filterNodes(node, (item : L.tree.Item) => {
                let layerService = item && item.layerService;
                if (!layerService) return false;

                if (layerService.attributes && layerService.attributes.PredefinedFeatureLayer) return true;

                if (layerService.koordinatesLayer && layerService.koordinatesLayer.forAreaQuery) return true;

                return (layerService.WFSLayers || [])
					.some((wfs) => wfs.forAreaQuery);
            });
        }

        export function isCustomLayerQueryable(node: Item): boolean {
			return node.isCustom && node.layerService && node.layerService['queryable'];
		}

		export function isLocalData(node: Item): boolean {
			return node.isLocalData;
		}

        export type ApiLayerFilter = (l : WFSLayer|KoordinatesLayer) => boolean;

        export function getLayersForPointQuery(node: Item|Item[], apiFilter: ApiLayerFilter = null): Item[] {
            return L.tree.filterNodes(node, (item : L.tree.Item) => {
                let layerService = item && item.layerService;
                if (!layerService) return false;

                if (layerService.koordinatesLayer
					&& layerService.koordinatesLayer.forPointQuery
					&& (!apiFilter || apiFilter(layerService.koordinatesLayer))) {
                	return true;
				}

				if (layerService.attributes && layerService.attributes.PredefinedFeatureLayer) {
					return true;
				}

                return (layerService.WFSLayers || [])
                    .some((wfs) => wfs.forPointQuery && (!apiFilter || apiFilter(wfs)));
            });
        }

		/**
		 * @param {L.tree.Item} node
		 * @return the layerName variable (for internal usage)
		 */
		export function getLayerName(node: Item) : string {
			return node && node.layerService && node.layerService.layerName;
		}

		export function getLayerId(node: Item): number {
			return node && node.layerService && node.layerService.id;
		}

		export function getClassById(nodes: Item|Item[], classId: number) : Item[] {
			return filterNodes(nodes, (n) => n.classId && n.classId == classId);
		}

		export function getLayerById(nodes: Item|Item[], layerId: number) : Item[] {
			return filterNodes(nodes, (n) => n.layerId && n.layerId == layerId);
		}

		export function getFeatureTitleProperty(node: Item) : string {
			const ls = node.layerService;
			if (ls) {
				if (ls.attributes && ls.attributes.PredefinedFeatureTitleProperty) {
					return ls.attributes.PredefinedFeatureTitleProperty;
				}
                const wfs = ls.WFSLayers;
                if (wfs.length) return wfs[0].titleProperty;

                if (ls.koordinatesLayer) return ls.koordinatesLayer.titleProperty;
			}

			return null;
        }

		export function getParents(node: Item) : Item[] {
			let parents = [];
			while(node && node.parent) {
				parents.push(node.parent);
				node = node.parent;
			}
			return parents;
		}

		export function getVisibleScienceLayer(node: Item | Item[]): Item {
			if (!node) return null;
			if (node instanceof Array) {
				for (let child of node) {
					let maybeLayer = getVisibleScienceLayer(child);
					if (maybeLayer) return maybeLayer;
				}
			} else {
				if (nodeIsScienceLayer(node)) {
					if (node.isChecked()) {
						return node;
					} else if (node.children && node.children.some((child) => child.isChecked())) return node;
				} else if (node.children) {
					for (let child of node.children) {
						let maybeLayer = getVisibleScienceLayer(child);
						if (maybeLayer) return maybeLayer;
					}
				}
				return null;
			}

		}

		export function checkLayerIfGroup(node: Item): void {
			if (node.layerType === 'SCI_GROUP') {
				node.children.forEach((node) => {
					node.checked = true;
					node.layer.setVisible(true);
				});
			}
		}
		export function checkChildrenIfCollectionOtherwiseCheckFirstChild(node: Item): void {
			console.log('clickItem', node);
			if (node.checkBehavior === 'UNION' || node.checkBehavior === 'UNION_SUB') {
				checkChildren(node);
			} else {
				checkFirstChild(node);
			}
		}
		function isChildSelected(node: Item) {
			if (!node.children) {
				return node.selected;
			}
			for (let c of node.children) {
				if (c.selected) {
					return true;
				}
			}
			return false;
		}
		export function isChecked(): boolean {
			let node: Item = this;
			if (node.selected) {
				node.checked = node.selected || isChildSelected(node);
				node.selected = false;
				return node.checked;
			}
			return node.checked;
			/*
			   let checkLayer = false;
			   let isBasemap = node.checkBehavior === 'BASEMAP';
			   let thisChecked = node.isChecked && node.isChecked();
			   let nodeChecked = node.checked;
			   return isBasemap || thisChecked || checkLayer || nodeChecked;
			 */
		}
		export function getSiblings(node: Item): Item[] {
			let siblings: Item[] = [];
			if (!node.parent) {
				return siblings;
			}
			for (let item of node.parent.children) {
				if (node === item) {
					continue;
				}
				siblings.push(item);
			}
			return siblings;
		}
		function uncheckNodes(nodes: Item[]): void {
			for (let item of nodes) {
				item.selected = item.checked = false;
				item.layer && item.layer.setVisible(false);
			}
		}
		export function uncheckChildren(node: Item, recursive: boolean = true): void {
			if (!node.children) {
				return;
			}
			for (let item of node.children) {
				item.checked = false;
				item.layer && item.layer.setVisible(false);
				if (recursive) {
					uncheckChildren(item);
				}
			}
		}
		function checkFirstChild(node: Item): void {
			let included = (node.children || []).filter((n) => {
				return n.extraState.metaLayerSelector.checked
			});

			if (included.length) {
				let c = included[0];
				c.checked = true;
				c.click(c);
			}
		}
		function handleBasemapCheckBehavior(node: Item): void {
			// uncheck all siblings
			let siblings = getSiblings(node);
			uncheckNodes(siblings); // only one base layer
			//node.checked = true; // ensure a base layer is on
		}
		/*
		function handleUnionCheckBehavior(node: Item): void {

		}
		function handleUnionSubCheckBehavior(node: Item): void {

		}
		*/
		function handleNode(node: Item): void {
			switch (node.parent.checkBehavior) {
				case 'BASEMAP':
					handleBasemapCheckBehavior(node);
					break;
				case 'UNION':
					// handleUnionCheckBehavior(node);
					break;
				// do nothing for now, later maybe something?
				case 'UNION_SUB':
					// handleUnionSubCheckBehavior(node);
					break;
			}
		}

		function uncheckOthersInXORGroup(node: Item): void {
			//let siblings = getSiblings(node);

			const groups = (node.xorGroup || '').split(',').map(s => s.trim()).filter(s => !!s);
			if (!groups.length) return;

			node.rootItems.forEach( (collection) => {
				collection.children.forEach((sibling) => {
					if (sibling === node) { // filter current node from children
						return;
					}

					const siblingGroups = (sibling.xorGroup || '').split(',').map(s => s.trim()).filter(s => !!s);
					if (siblingGroups.some(g => groups.includes(g))) {
						sibling.checked = false;
						if (sibling.layer) {
							sibling.layer.setVisible(false);
						}
						uncheckChildren(sibling);
					}
				});
			});
		}
		/*
		export function findClosestCheckedLayersWithLayerNames(node: Item): Item[] {
			let checked = node.isChecked();
			let checkedSiblings: Item[] = [];
			if (checked && node.layerService && node.layerService.layerName) {
				checkedSiblings.push(node); // assume node is checked
				let siblings = getSiblings(node);
				checkedSiblings = checkedSiblings.concat(siblings.filter((node) => node.isChecked()));
				return checkedSiblings.filter((s) =>
					s.layerService && s.layerService.layerName);
			}
			return checkedSiblings;
		}
		*/
		/*
		export function findClosestCheckedLayerNames(node: Item): string[] {
			return findClosestCheckedLayersWithLayerNames(node)
				.map((n) => n.layerService.layerName);
		}
		*/
		export function clickItem(node: Item): void {
			/**
			 * When a child node is checked/clicked, its parent should be unchecked
			 * if all its child nodes are unchecked/off.
			 * We also need the Base Map layers to alternate and the UNION layers
			 * to be able to have more than one checked.
			 */
			if (node.parent) {
				handleNode(node);
			}
			if (node.checked) {
				checkChildrenIfCollectionOtherwiseCheckFirstChild(node);
				checkLayerIfGroup(node);
				uncheckOthersInXORGroup(node);
			} else if (!node.checked) {
				uncheckChildren(node);
				// if base layer do NOT make it possible for none to be selected
				if (!node.checked && !node.isCustom && node.layerType === 'BASE' && !node.children.filter(c => c !== node).some(c => c.checked)) {
					node.checked = true;
				}
			}
			let parent = node.parent;
			while (parent) {
				let checked = false;
				for (let item of parent.children) {
					if (item.checked) {
						checked = true;
						break;
					}
				}
				parent.checked = checked;
				if (parent.checked) {
					// the parent may be in an XOR group
					uncheckOthersInXORGroup(parent);
				}
				parent = parent.parent;
			}
			if (!node.checked && node.children && node.children.length > 0) {
				// if unchecked, uncheck the children
				uncheckChildren(node);
			}

			visibleLayer(node);
			//showLegend(node);
			//showMetaData(node);
			node.rootItems.forEach((n) => {
				if (!filterNodes(n.children, (c) => c.checked).length) {
					n.checked = false;
				}
			});
		}
		export function visibleLayer(node: Item): void {
			if (node.layer && node.layerType !== 'SCI_GROUP') {
				node.layer.setVisible(node.checked);
			}
		}
		export function nodeToggle(node: Item): void {
			if (node.isChecked()) {
				L.tree.checkChildren(node);
			}
		}

		/*export function showMetaData($http : ng.IHttpService, node: Item): void {
			let metaDataPane: string = '#PaneMetadata .pane-content';
			// let mobileMetaDataPane: string = '#PaneLegend .pane-content .legend-container-mobile';
			let mobileMetaDataPane : string = '.metadata-container';
			let layers: string = '';
			let layerName: string = '';
			let count: number = 0;
			let additionalMessage: string = '';
			//console.log('we are at showMetaData() + node.name is ' + node.name + ' and node.isChecked is ' + node.isChecked()); // + ' and node.children.length is ' + node.children.length);
			if (node == undefined || !node.isChecked()) {
				//console.log('we want to show nothing for meta description.');
				//$(metaDataPane).html('');
				return;
			}
			try {
				//console.log('node.classId ' + node.classId + ' and layerService is ' + node.layerService + ' and layerName is ' + node.layerService.layerName);
			} catch(e) {

			}
			if(node.layerService != undefined) {
				//console.log('node.layerService is not undefined');
				layers = node.layerService.layerName;
			} else if(node.layerType == undefined && node.children != undefined && node.children.length > 0) {
				//console.log('here2');
				node.children.forEach((childNode) => {
					count = count+1;
					//console.log('here3 and count is ' + count + ' and layers is ' + layers);
					layerName = childNode.layerService.layerName;
					if(layerName != undefined) {
						//console.log('******* layerName is ' + layerName);
						layers += layerName + ',';
						//console.log('(zzz) layers is ' + layers);
					}
				});
			} else {
				layers = node.parent.layerService.layerName;
			}
			//console.log('layers is ----> ' + layers  + '<--------');
			if(node.name === 'Context layers') {
				additionalMessage = '<p>The layers in this category (e.g. cartographic text, transport and water) can be overlaid on your map as contextual information.</p>';
			}
			if(layers != '') {
				let url: string = 'services/layer_meta_info/json?layers=';
				let layerNames: string = layers;
				url += layerNames;
				//console.log('showMetaData - URL is ' + url);
				// request json from backend service
				$http.get(url).then((data) => {
					angular.element(metaDataPane).html(createResponseDivForMetaData(data, additionalMessage));
					angular.element(mobileMetaDataPane).append('<h4>Meta Description</h4>');
					angular.element(mobileMetaDataPane).append(createResponseDivForMetaData(data, additionalMessage));
				});
			}
		}*/
		/*
		function createResponseDivForMetaData(data:any, additionalMessage:string) {
			let html: string = additionalMessage;
			for (let record of data.response) {
				//console.log('record.title is ' + record.title);
				html += '<dl>';
				html += '<dt>Title</dt>';
				html += '<dd>' + record.title + '</dd>';
				html += '<dt>Description</dt>';
				html += '<dd>' + record.description + '</dd>';
				html += '</dl>';
			}
			return html;
		}
		*/
		export function getAllCheckedNodes(node: Item): Item[] {
			// looks at children even if a parent isn't checked
			let nodes = [];
			if (node.isChecked()) {
				nodes.push(node);
			}

			if (node.children && node.children.length) {
				for (let child of node.children) {
					nodes = nodes.concat(getCheckedNodes(child));
				}
			}

			return nodes;
		}
		export function getLayerNames(nodes: Item[]): string[] {
			return nodes.filter((n) => n.layerService && n.layerService.layerName).map((n) => n.layerService.layerName);
		}
		export function getCheckedNodes(node: Item): Item[] {
			// will not look at children even if a parent isn't checked
			if (node.isChecked()) {
				let nodes = [node];
				if (node.children && node.children.length) {
					for (let child of node.children) {
						nodes = nodes.concat(getCheckedNodes(child));
					}
				}
				return nodes;
			}
			return [];
		}
		/*
		export function getCheckedClassIds(node: Item): number[] {
			return getCheckedNodes(node).filter((n) => n.classId).map((n) => n.classId);
		}
		export function getCheckedLayerIds(node: Item): number[] {
			return getCheckedNodes(node).filter((n) => n.layerId).map((n) => n.layerId);
		}
		*/
		/*
		export function showLegend($http : ng.IHttpService, node: Item): void {
			console.log('NODE', node);
			// let legendPane: string = '#PaneLegend .pane-content .legend-container';
			// let mobileLegendPane: string = '#PaneLegend .pane-content .legend-container-mobile';
			// let html: string = '';
			let layerIds = getCheckedLayerIds(node);
			let classIds = getCheckedClassIds(node);
			console.log('checked LAYER IDS', layerIds);
			console.log('checked CLASS IDS', classIds);
			$http.get('/services/portal_configuration/layer_class/' + layerIds.join(','));
			// $.getJSON('/services/portal_configuration/layer_class/' + layerIds.join(','));
		}
		*/
	}
}

